import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataYEYBMICZYFP/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataYEYBMICZYFP/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataYEYBMICZYFP/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataYEYBMICZYFP/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataYEYBMICZYFP/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataYEYBMICZYFP/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataYEYBMICZYFP/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataYEYBMICZYFP/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataYEYBMICZYFP/update/batch',
    method: 'POST',
    data})
}

   